import React from "react";
import PdfBase from "./PdfBase";
import { generateOtherIncomePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  otherIncomeRows,
  expensesRows,
  totalOtherIncome,
  totalExpenses,
  netOtherIncome,
  foreignTaxSettings,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    otherIncomeRows,
    expensesRows,
    totalOtherIncome,
    totalExpenses,
    netOtherIncome,
    foreignTaxSettings,
    notes,
    reviewNotes,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateOtherIncomePdf(forView, ...sharedArgs)
        }
        downloadName={schedule.name || schedule.type}
      />

      <ExcelBase
        generateExcel={(forView) =>
          generateOtherIncomePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
